import { render, staticRenderFns } from "./StudentCourseAssignments.vue?vue&type=template&id=4725c56e&scoped=true"
import script from "./StudentCourseAssignments.vue?vue&type=script&lang=js"
export * from "./StudentCourseAssignments.vue?vue&type=script&lang=js"
import style0 from "./StudentCourseAssignments.vue?vue&type=style&index=0&id=4725c56e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4725c56e",
  null
  
)

export default component.exports